import { render, staticRenderFns } from "./BlockStatistics.vue?vue&type=template&id=683fde57"
import script from "./BlockStatistics.vue?vue&type=script&lang=js"
export * from "./BlockStatistics.vue?vue&type=script&lang=js"
import style0 from "./BlockStatistics.vue?vue&type=style&index=0&id=683fde57&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports